import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './AdminHeader.css';

class AdminHeader extends Component {
	state = {
		showModal: false,
		formType: ''
	};

	toggleModal = () => {
		this.setState({
			showModal: !this.state.showModal
		});
	};

	render() {
		// console.log('admin header: ', this.props.history)
		return (
			<div className="admin-header">
				{this.props.history.location.pathname === '/admin/users' || this.props.history.location.pathname === '/admin/users/' ? (
					<div className="admin-header-title">
						<span>ADMINISTRATION</span> <i className="fas fa-angle-right" />{' '}
						<span>STAFF</span>
					</div>
				) : this.props.history.location.pathname === '/admin/membership' || this.props.history.location.pathname === '/admin/membership/' ? (
					<div className="admin-header-title">
						<span>MEMBERSHIPS</span> <i className="fas fa-angle-right" />{' '}
						<span>MEMBERSHIP</span>
					</div>
				) : this.props.history.location.pathname === '/admin/membershipusers' || this.props.history.location.pathname === '/admin/membershipusers/' ? (
					<div className="admin-header-title">
						<span>MEMBERSHIP</span> <i className="fas fa-angle-right" />{' '}
						<span>MEMBERSHIPS USERS</span>
							</div>
				) : this.props.history.location.pathname === '/admin/memberdiscounts' || this.props.history.location.pathname === '/admin/memberdiscounts/' ? (
					<div className="admin-header-title">
						<span>MEMBERSHIP</span> <i className="fas fa-angle-right" />{' '}
						<span>MEMBER DISCOUNTS</span>
					</div>
				) : this.props.history.location.pathname === '/admin/membershiprequests' || this.props.history.location.pathname === '/admin/membershiprequests/' ? (
					<div className="admin-header-title">
						<span>MEMBERSHIP</span> <i className="fas fa-angle-right" />{' '}
						<span>MEMBERSHIP REQUESTS</span>
					</div>
				) : this.props.history.location.pathname === '/admin/organization' || this.props.history.location.pathname === '/admin/organization/' ? (
					<div className="admin-header-title">
						<span>ORGANIZATIONS</span> <i className="fas fa-angle-right" />{' '}
						<span>ORGANIZATION</span>
					</div>
				) : this.props.history.location.pathname === '/admin/districts' || this.props.history.location.pathname === '/admin/districts/' ? (
					<div className="admin-header-title">
						<span>ADMINISTRATION</span> <i className="fas fa-angle-right" />{' '}
						<span>DISTRICTS</span>
					</div>
				) : this.props.history.location.pathname === '/admin/regions' || this.props.history.location.pathname === '/admin/regions/' ? (
					<div className="admin-header-title">
						<span>ADMINISTRATION</span> <i className="fas fa-angle-right" />{' '}
						<span>REGIONS</span>
					</div>
				) : this.props.history.location.pathname === '/admin/committees' || this.props.history.location.pathname === '/admin/committees/' ? (
					<div className="admin-header-title">
						<span>ADMINISTRATION</span> <i className="fas fa-angle-right" />{' '}
						<span>COMMITTEES</span>
					</div>
				) : this.props.history.location.pathname === '/admin/positions' || this.props.history.location.pathname === '/admin/positions/' ? (
					<div className="admin-header-title">
						<span>ADMINISTRATION</span> <i className="fas fa-angle-right" />{' '}
						<span>POSITIONS</span>
					</div>
				) : this.props.history.location.pathname === '/admin/groups' || this.props.history.location.pathname === '/admin/groups/' ? (
					<div className="admin-header-title">
						<span>ADMINISTRATION</span> <i className="fas fa-angle-right" />{' '}
						<span>POSITION GROUPS</span>
					</div>
				) :  this.props.history.location.pathname === '/admin/events' || this.props.history.location.pathname === '/admin/events/' ? (
					<div className="admin-header-title">
						<span>EVENT MANAGEMENT</span> <i className="fas fa-angle-right" />{' '}
						<span>EVENTS</span>
					</div>
				)
				:  this.props.history.location.pathname === '/admin/colors' || this.props.history.location.pathname === '/admin/colors/' ? (
					<div className="admin-header-title">
						<span>PRODUCTS</span> <i className="fas fa-angle-right" />{' '}
						<span>COLORS</span>
					</div>
				):  this.props.history.location.pathname === '/admin/sizes' || this.props.history.location.pathname === '/admin/sizes/' ? (
					<div className="admin-header-title">
						<span>PRODUCTS</span> <i className="fas fa-angle-right" />{' '}
						<span>SIZES</span>
					</div>
				):  this.props.history.location.pathname === '/admin/archive' || this.props.history.location.pathname === '/admin/archive/' ? (
					<div className="admin-header-title">
						<span>MAGAZINE</span> <i className="fas fa-angle-right" />{' '}
						<span>ARCHIVE</span>
					</div>
				):
				this.props.history.location.pathname === '/admin/productTypes' || this.props.history.location.pathname === '/admin/productTypes/' ? (
					<div className="admin-header-title">
						<span>PRODUCTS</span> <i className="fas fa-angle-right" />{' '}
						<span>PRODUCT CATEGORIES</span>
					</div>
				):
				this.props.history.location.pathname === '/admin/products' || this.props.history.location.pathname === '/admin/products/' ? (
					<div className="admin-header-title">
						<span>PRODUCTS</span> <i className="fas fa-angle-right" />{' '}
						<span>PRODUCTS</span>
					</div>
				):
				this.props.history.location.pathname === '/admin/subscription' || this.props.history.location.pathname == '/admin/subscription/' ? (
					<div className="admin-header-title">
						<span>MAGAZINE</span> <i className="fas fa-angle-right" />{' '}
						<span>SUBSCRIPTIONS</span>
					</div>
				):
				this.props.history.location.pathname === '/admin/orderManagement' || this.props.history.location.pathname === '/admin/orderManagement/' ? (
					<div className="admin-header-title">
						<span>PRODUCTS</span> <i className="fas fa-angle-right" />{' '}
						<span>ORDER MANAGEMENT</span>
					</div>
				):
				this.props.history.location.pathname === '/admin/invoices' || this.props.history.location.pathname === '/admin/invoices/' ? (
					<div className="admin-header-title">
                        <span>ACCOUNTING </span> <i className="fas fa-angle-right" />{' '}
						<span>INVOICES</span>
					</div>
				):
				this.props.history.location.pathname === '/admin/purchaseandrenewals' || this.props.history.location.pathname === '/admin/purchaseandrenewals/' ? (
					<div className="admin-header-title">
						<span>ACCOUNTING</span> <i className="fas fa-angle-right" />{' '}
                        <span>PURCHASE AND RENEWALS</span>
					</div>
				):
				this.props.history.location.pathname === '/admin/batches' || this.props.history.location.pathname === '/admin/batches/' ? (
					<div className="admin-header-title">
						<span>ACCOUNTING</span> <i className="fas fa-angle-right" />{' '}
                        <span>BATCHES</span>
					</div>
				):
				this.props.history.location.pathname === '/admin/donations' || this.props.history.location.pathname === '/admin/donations/' ? (
					<div className="admin-header-title">
						<span>REPORTING</span> <i className="fas fa-angle-right" />{' '}
                        <span>DONATIONS</span>
					</div>
				):(
					<h2>Default Header</h2>
				)}
        <div className="copyright-text version-number">Version: {global.appVersion}</div>
			</div>
		);
	}
}

export default withRouter(AdminHeader);
